import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getPageName } from '@/utils/MYINCOME/pageNameMap';

/**
 * 全局路由追踪组件
 * - 路由切换时触发 PageStay 事件（记录离开页面）
 * - 路由切换时触发 PageView 事件（记录进入新页面）
 * - 通过 registerPage 注册 page_name，使其他事件也携带该字段
 */
const RouteChangeTracker = () => {
  const location = useLocation();
  const prevPath = useRef(location.pathname + location.search);
  const prevPathname = useRef(location.pathname);
  const enterTime = useRef(Date.now());

  // 首次进入时注册当前页面的 page_name
  useEffect(() => {
    const sensors = window.$sensors?.sensors;
    if (sensors) {
      sensors.registerPage({
        page_name: getPageName(location.pathname),
      });
    }
  }, []);

  useEffect(() => {
    const currentPath = location.pathname + location.search;
    
    // 路由变化时触发
    if (prevPath.current !== currentPath) {
      const stayTime = Date.now() - enterTime.current;
      const sensors = window.$sensors?.sensors;
      
      if (sensors) {
        const prevPageName = getPageName(prevPathname.current);
        const currentPageName = getPageName(location.pathname);
        
        // 1. 发送 PageStay 事件（离开上一个页面）
        sensors.track('PageStay', {
          page_url: window.location.origin + prevPath.current,
          page_path: prevPathname.current,
          page_name: prevPageName,
          event_duration: Number((stayTime / 1000).toFixed(3)),
        });
        
        // 2. 发送 PageView 事件（进入新页面）
        sensors.track('PageView', {
          page_url: window.location.href,
          page_path: location.pathname,
          page_name: currentPageName,
          page_title: document.title,
        });
        
        // 3. 更新 registerPage 为当前页面的 page_name
        sensors.registerPage({
          page_name: currentPageName,
        });
      }

      // 更新状态
      prevPath.current = currentPath;
      prevPathname.current = location.pathname;
      enterTime.current = Date.now();
    }
  }, [location]);

  return null;
};

export default RouteChangeTracker;

